import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box } from '@chakra-ui/react';
import { clientLogger, getClientDefaultSessionTracing } from '@whitbread-eos/utils';
import { withTranslation } from 'next-i18next';
import React from 'react';
import { Alert } from '../../assets/icons';
import Notification from '../Notification';
import StaticFooter from './StaticFooter';
import StaticHeader from './StaticHeader';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends React.Component {
  constructor(props) {
    var _this$onError, _props$isFooterBounda, _props$isHeaderBounda, _props$noContentBound, _props$errorMessage;
    super(props);
    _defineProperty(this, "state", {
      error: undefined
    });
    _defineProperty(this, "onError", console.error);
    this.onError = (_this$onError = this.onError) !== null && _this$onError !== void 0 ? _this$onError : props.onError;
    this.t = props.t;
    this.isFooterBoundary = (_props$isFooterBounda = props.isFooterBoundary) !== null && _props$isFooterBounda !== void 0 ? _props$isFooterBounda : false;
    this.isHeaderBoundary = (_props$isHeaderBounda = props.isHeaderBoundary) !== null && _props$isHeaderBounda !== void 0 ? _props$isHeaderBounda : false;
    this.noContentBoundary = (_props$noContentBound = props.noContentBoundary) !== null && _props$noContentBound !== void 0 ? _props$noContentBound : false;
    this.errorMessage = (_props$errorMessage = props.errorMessage) !== null && _props$errorMessage !== void 0 ? _props$errorMessage : this.t('errors.sorry');
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    var sessionTracing = getClientDefaultSessionTracing();
    var errorDetails = {
      label: 'ERROR_BOUNDARY',
      err: error.message,
      errorInfo: errorInfo,
      sessionId: sessionTracing['WB-SESSION-ID']
    };
    if (typeof window !== 'undefined' && typeof CustomEvent !== 'undefined') {
      window.dispatchEvent(new CustomEvent('error_boundary_triggered', {
        detail: errorDetails
      }));
    }
    clientLogger.error(errorDetails);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.error && !prevState.error) {
      this.onError(this.state.error);
    }
  }
  render() {
    if (this.state.error) {
      if (this.isFooterBoundary) {
        return _jsx(StaticFooter, {});
      }
      if (this.isHeaderBoundary) {
        return _jsx(StaticHeader, {});
      }
      if (this.noContentBoundary) {
        return null;
      }
      return _jsx(Box, {
        mt: "lg",
        children: _jsx(Notification, {
          status: "warning",
          description: this.errorMessage,
          variant: "alert",
          maxW: "full",
          svg: _jsx(Alert, {})
        })
      });
    }
    return this.props.children;
  }
}
_defineProperty(ErrorBoundary, "defaultProps", {
  isFooterBoundary: false,
  isHeaderBoundary: false,
  noContentBoundary: false
});
export default withTranslation(['common'])(ErrorBoundary);